import React from "react";
import { X } from "lucide-react";

const getInitials = (name = "") => {
  const clean = name.split("@")[0].replace(/[._-]/g, " ").trim();
  const parts = clean.split(" ").filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return clean.slice(0, 2).toUpperCase();
};

const getAvatarColor = (name = "") => {
  const colors = [
    "bg-blue-500", "bg-emerald-500", "bg-violet-500",
    "bg-orange-500", "bg-pink-500", "bg-teal-500",
    "bg-rose-500", "bg-indigo-500",
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
};

const Popup = ({ title, items = [], type = "text", onClose }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
    onClick={onClose}
  >
    <div
      className="bg-white rounded-2xl shadow-2xl w-full max-w-xl mx-4 flex flex-col max-h-[80vh]"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div
        className="flex items-center justify-between px-6 py-4 border-b border-gray-100 rounded-t-2xl"
        style={{ backgroundColor: "#EDE9FE" }}
      >
        <h3 className="text-base font-semibold text-gray-800">{title}</h3>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X size={20} />
        </button>
      </div>

      {/* List */}
      <div className="overflow-y-auto flex-1 px-4 py-3 space-y-2">
        {items.map((value, i) => (
          <div
            key={i}
            className="flex items-center gap-3 px-3 py-3 rounded-lg bg-gray-50 hover:bg-teal-100 transition-colors"
          >
            <span className="flex-shrink-0 w-[28px] h-[28px] rounded-full bg-gray-200 text-gray-600 text-xs font-semibold flex items-center justify-center">
              {i + 1}
            </span>
            {type === "avatar" ? (
              <div className="flex items-center gap-2 min-w-0">
                <span className={`w-[32px] h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0 ${getAvatarColor(value)}`}>
                  {getInitials(value)}
                </span>
                <span className="text-sm text-gray-700 truncate">{value}</span>
              </div>
            ) : (
              <span className="text-sm text-gray-700 font-medium break-all whitespace-normal">{value}</span>
            )}
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between px-6 py-3 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
        <span className="text-xs text-gray-500 font-medium">
          TOTAL ITEMS: {items.length}
        </span>
        <button
          onClick={onClose}
          className="px-4 py-1.5 text-sm font-medium text-white rounded-lg transition-colors hover:opacity-90"
          style={{ backgroundColor: "#bb1ccc" }}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

export default Popup;